"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcWorksheetInvoiceLineAccountings = class UcWorksheetInvoiceLineAccountings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    worksheet;
    onWorksheet(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("worksheet");
    }
    isReadonly;
    onIs_readonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("isReadonly");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('query_invoice_line_accounting_for_worksheet', { parameters: { id: this.worksheet.id } });
    }
    ux;
    b_5962862420439144_rowHeader;
    b_5962862420439144_paging;
    b_5962862420439144_sortable;
    b_5962862420439144_editable;
    b_5962862420439144_columns;
    dataMembers = ['items', 'ux', 'b_5962862420439144_rowHeader', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_editable', 'b_5962862420439144_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: {
                    errorHandling: "local",
                    initialLoadSpinner: true,
                },
                b_5962862420439144_rowHeader: false,
                b_5962862420439144_paging: false,
                b_5962862420439144_sortable: false,
                b_5962862420439144_editable: false,
                b_5962862420439144_columns: [{
                        name: "invoice_number",
                        header: this.$fn.gettext("Invoice Number"),
                        formatter: {
                            name: "template",
                            value: "<div v-if=\"value\" class=\"text-left\">\n\
  <ItpLink :to=\"{ name: 'app.invoice', params: {id: row.invoice_id}}\">\n\
    {{ value }}\n\
  </ItpLink>\n\
</div>\n\
",
                        },
                    },
                    {
                        name: "product_description",
                        header: this.$fn.gettext("Description"),
                        formatter: {
                            name: "template",
                            value: "<div v-if=\"value\" class=\"text-left\">\n\
  <ItpLink :to=\"{ name: 'app.product', params: {id: row.product_id}}\">\n\
    {{ value }}\n\
  </ItpLink>\n\
</div>\n\
",
                        },
                    },
                    {
                        name: "quantity",
                        type: "number",
                        header: this.$fn.gettext("Quantity"),
                        width: "150px",
                    },
                    {
                        name: "unit",
                        header: this.$fn.pgettext("abbreviated", "Unit"),
                    },
                    {
                        name: "unit_price",
                        header: this.$fn.gettext("Unit Price"),
                        type: "number",
                    },
                    {
                        name: "amount",
                        header: this.$fn.gettext("Amount"),
                        type: "number",
                    },
                    {
                        name: "expense_type",
                        header: this.$fn.gettext("Expense Type"),
                        formatter: {
                            name: "template",
                            value: "<div v-if=\"value\">\n\
  {{ value|pgettext('ExpenseType', 'Sentence') }}\n\
</div>\n\
",
                        },
                    },
                    {
                        name: "cost_center",
                        header: this.$fn.gettext("Cost Center"),
                    },
                    {
                        name: "handover_date",
                        header: this.$fn.gettext("Handover Date"),
                        type: "date",
                    },
                    {
                        name: "notes",
                        header: this.$fn.gettext("Notes"),
                    },
                ],
            },
        };
    }
    async act_5962862420439144_script_8320_getActionArgs_value($event) {
        this.worksheet.id
            ? $event.data.waitFor(this.$fn.crud('work_item').upsert($event.data.row))
            : this.worksheet.work_items.push($event.data.row);
    }
    async act_5962862420439144_script_8320_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8320_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_save(event, scope) {
        return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_8322_getActionArgs_value($event) {
        this.worksheet.id
            ? $event.data.waitFor(this.$fn.crud('work_item').delete($event.data.row))
            : _.remove(this.worksheet.work_items, $event.data.row);
    }
    async act_5962862420439144_script_8322_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_8322_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_delete(event, scope) {
        return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_script_8320 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8320_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_save_8319 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8320,
            event: "save",
            displayName: "script",
        });
        const evh_5962862420439144_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_save_8319],
        });
        const act_5962862420439144_script_8322 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_8322_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_delete_8321 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_8322,
            event: "delete",
            displayName: "script",
        });
        const evh_5962862420439144_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_delete_8321],
        });
        return {
            act_5962862420439144_script_8320,
            evh_5962862420439144_save_8319,
            evh_5962862420439144_save,
            act_5962862420439144_script_8322,
            evh_5962862420439144_delete_8321,
            evh_5962862420439144_delete,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcWorksheetInvoiceLineAccountings.prototype, "worksheet", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('worksheet'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcWorksheetInvoiceLineAccountings.prototype, "onWorksheet", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcWorksheetInvoiceLineAccountings.prototype, "isReadonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isReadonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcWorksheetInvoiceLineAccountings.prototype, "onIs_readonly", null);
UcWorksheetInvoiceLineAccountings = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcWorksheetInvoiceLineAccountings);
exports.default = UcWorksheetInvoiceLineAccountings;
vue_property_decorator_1.Vue.component("UcWorksheetInvoiceLineAccountings", UcWorksheetInvoiceLineAccountings);
